import axios from "axios";
import API from "../helpers/api";
import { uiRoleToApi } from "../helpers/clientContactUserRole";

const silentRequest = { skipGlobalLoader: true };

export const getCurrentUserName = () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  return currentUser?.name || "";
};

export const searchClientUsersMaster = (searchData) => {
  const role = uiRoleToApi(searchData.Role);
  const params = new URLSearchParams({
    Name: searchData.Name || "",
    Email: searchData.Email || "",
    Phone: searchData.Phone || "",
    Role: role || "",
    PageNumber: String(searchData.PageNumber || 1),
    PageSize: String(searchData.PageSize || 15),
  });

  return axios.get(`${API.searchClientUsersMaster}?${params.toString()}`, silentRequest);
};

export const getClientUsersMasterById = (clientUsersMasterId) =>
  axios.get(`${API.getClientUsersMaster}?clientUsersMasterId=${clientUsersMasterId}`, silentRequest);

export const createClientUsersMaster = (payload) =>
  axios.post(API.createClientUsersMaster, payload, silentRequest);

export const updateClientUsersMaster = (payload) =>
  axios.put(API.updateClientUsersMaster, payload, silentRequest);

export const getUsersApplicableClients = (clientUsersMasterId) =>
  axios.get(`${API.getUsersApplicableClients}?clientUsersMasterId=${clientUsersMasterId}`, silentRequest);

export const getAvailableClients = (clientUsersMasterId, search, config = {}) => {
  const params = new URLSearchParams({
    clientUsersMasterId: String(clientUsersMasterId),
    search: search || "",
  });
  return axios.get(`${API.getAvailableClients}?${params.toString()}`, {
    ...silentRequest,
    ...config,
  });
};

export const assignClientToUser = (payload) =>
  axios.post(API.assignUsersApplicableClient, payload, silentRequest);

export const unassignClientFromUser = (payload) =>
  axios.put(API.unassignUsersApplicableClient, payload, silentRequest);

export const getClientUserVessels = (
  usersApplicableClientId,
  selectedSearch,
  remainingSearch
) => {
  const params = new URLSearchParams({
    usersApplicableClientId: String(usersApplicableClientId),
    selectedSearch: selectedSearch || "",
    remainingSearch: remainingSearch || "",
  });
  return axios.get(`${API.getClientUserVessels}?${params.toString()}`, silentRequest);
};

export const syncClientUserVessels = (payload) =>
  axios.put(API.syncClientUserVessels, payload, silentRequest);

export const isApiSuccess = (data) => {
  if (data === true || data === "true") {
    return true;
  }
  return typeof data === "string" && data.trim().toLowerCase() === "true";
};

export const getClientUserApiErrorMessage = (data, fallbackMessage) => {
  if (!data) {
    return fallbackMessage;
  }

  const message = typeof data === "string" ? data.trim() : String(data);
  const normalized = message.toLowerCase();

  if (normalized === "failed") {
    return "Unable to create the user in identity server. Please try again or contact support.";
  }

  if (normalized === "false") {
    return "A user with this email already exists.";
  }

  if (normalized === "invalid role") {
    return "Invalid role selected.";
  }

  return message || fallbackMessage;
};

export const normalizeAvailableClient = (client) => ({
  clientId: client.clientId ?? client.ClientId,
  clientName: client.clientName ?? client.ClientName ?? "",
});

export const normalizeVessel = (vessel) => ({
  shipId: vessel.shipId ?? vessel.ShipId,
  shipName: vessel.shipName ?? vessel.ShipName ?? "",
  vesselType: vessel.vesselType ?? vessel.VesselType ?? "",
});

export const normalizeVesselsResponse = (data) => {
  const selected = data?.selected ?? data?.Selected ?? [];
  const remaining = data?.remaining ?? data?.Remaining ?? [];

  return {
    selected: selected.map(normalizeVessel).filter((vessel) => vessel.shipId),
    remaining: remaining.map(normalizeVessel).filter((vessel) => vessel.shipId),
  };
};
